import { authenticateUser } from "../../services/auth/login";
import { LOGIN_SUCCESS, LOGIN_FAILURE } from "../constants";
import Cookies from "js-cookie";

export const login =
  (
    credentials,
    navigate,
    setLoading,
    toast,
    setStep,
    setEmail,
    setPassword,
    setEnteredCaptcha,
  ) =>
  (dispatch) => {
    setLoading(true);
    authenticateUser(credentials)
      .then((response) => {
        const { token, user_info, category_data, panel_projects } =
          response.data;
        dispatch({
          type: LOGIN_SUCCESS,
          payload: { token, user_info, category_data, panel_projects },
        });
        if (response.data.success === 1) {
          localStorage.clear();
          sessionStorage.clear();
          document.cookie.split(";").forEach((cookie) => {
            const eqPos = cookie.indexOf("=");
            const name =
              eqPos > -1 ? cookie.substr(0, eqPos).trim() : cookie.trim();
            document.cookie = `${name}=;expires=Thu, 01 Jan 1970 00:00:00 GMT;path=/`;
          });
          setLoading(false);
          if (
            response.data.user_info.type === "client" ||
            response.data.user_info.type === "admin_user"
          ) {
            navigate("/dashboard");
            return response.data;
          } else {
            Cookies.set("selectedMenu", "/admin-panel", { expires: 7 });
            navigate("/admin-panel");
            return response.data;
          }
        } else {
          setLoading(false);
          // Handle unsuccessful login if success !== 1
          dispatch({
            type: LOGIN_FAILURE,
            payload: "Login failed: Invalid credentials",
          });
        }
      })
      .catch((error) => {
        setLoading(false);
        setStep(1);
        setEmail("");
        setPassword("");
        setEnteredCaptcha("");
        // Dispatch error message from response if available, fallback to error.message
        const errorMessage =
          error.response && error.response.data && error.response.data.message
            ? error.response.data.message
            : error.message || "Login failed";
        toast.current.show({
          severity: "error",
          summary: "Login Error",
          detail: errorMessage,
          life: 3000,
        });
        dispatch({
          type: LOGIN_FAILURE,
          payload: errorMessage,
        });
      });
  };
